import { render } from "./AddEditEmployee.vue?vue&type=template&id=4577ab1b&ts=true"
import script from "./AddEditEmployee.vue?vue&type=script&lang=ts"
export * from "./AddEditEmployee.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__